export default __webpack_public_path__ + "static/media/jimmy.6457024b.jpg";